import React, { useState, forwardRef } from 'react'

// Plain <input type="date"> fields, not the shared <Input> component —
// matches the convention already established for the same kind of field on
// Generate.js's own "Slutdatum" input and History.js's date filter.
// A string slice, never new Date(...).toISOString(). The column is wall clock, and this is
// the PUT-back path (submitForm sends these values straight to updateDates) — re-parsing then
// re-serializing through UTC slipped a day for any round timestamped after 22:00 at UTC+2,
// so saving the dialog without touching a field permanently moved the round.
const toDateInputValue = (timestamp) => timestamp ? String(timestamp).slice(0, 10) : ''

const _EditDatesForm = ({ data, submitForm, loading, setLoading }, ref) => {
  const [generationTimestamp, setGenerationTimestamp] = useState(toDateInputValue(data.generation_timestamp))
  const [roundEndTimestamp, setRoundEndTimestamp] = useState(toDateInputValue(data.round_end_timestamp))
  const [invalid, setInvalid] = useState(null)

  const onSubmit = (event) => {
    event.preventDefault()
    setLoading(true)

    if (!generationTimestamp) {
      setInvalid('Startdatum krävs.')
      setLoading(false)
      return
    }
    if (roundEndTimestamp && roundEndTimestamp < generationTimestamp) {
      setInvalid('Slutdatum kan inte vara före startdatum.')
      setLoading(false)
      return
    }
    setInvalid(null)

    submitForm({ generationTimestamp, roundEndTimestamp: roundEndTimestamp || null })
    setLoading(false)
  }

  return (
    <div className="bud-edit-dates-form">
      <form onSubmit={onSubmit} ref={ref}>
        <div className="form-block vertical">
          <label>Startdatum</label>
          <input
            type="date"
            className="bud-plain-input"
            value={generationTimestamp}
            onChange={e => setGenerationTimestamp(e.target.value)}
            disabled={loading}
          />
        </div>

        <div className="form-block vertical">
          <label>Slutdatum<span className="bud-optional">(valfritt)</span></label>
          <input
            type="date"
            className="bud-plain-input"
            value={roundEndTimestamp}
            onChange={e => setRoundEndTimestamp(e.target.value)}
            disabled={loading}
          />
        </div>

        {invalid && <p className="bud-form-notice">{invalid}</p>}
      </form>
    </div>
  )
}

export const EditDatesForm = forwardRef(_EditDatesForm)
